import { connect } from 'react-redux';
import { getActiveBreakpointName } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { cloneSection, removeSection
// @ts-expect-error Could not find a declaration file for module ...
} from 'EmailEditorUI/redux/actions/LayoutActions';
import { getCanHideSection, sectionHasBlogRssModule as getSectionHasBlogRssModule, sectionHasWebversionAndIsVariant as getSectionHasWebversionAndIsVariant } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
// @ts-expect-error Could not find a declaration file for module ...
import { getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { getSectionOptionsKeys } from 'EmailEditorUI/redux/selectors/sectionOptionsSelectors';
import { getCanSaveLayouts, getPortalHasSavedLayouts } from 'EmailEditorUI/redux/selectors/AuthSelectors';
// @ts-expect-error Could not find a declaration file for module ...
import { getSectionById } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { getScrollPositionForSectionToolbar } from 'LayoutBuilderUI/utils/scrollPositionUtils';
import { getScrollContainerBoundaries } from 'LayoutBuilderUI/selectors/userInterface';
// @ts-expect-error Could not find a declaration file for module ...
import { AsyncSectionToolbar } from 'LayoutBuilderUI/components/AsyncComponents';
import { updateSectionBreakpointStyle } from 'EmailEditorUI/redux/actions/sidebarActions';
import { getIsTrellisTheme } from 'EmailEditorUI/redux/selectors/appStatusSelectors';
const mapStateToProps = (state, ownProps) => {
  const isSingleColumnFullWidth = getIsSingleColumnFullWidth(state);
  const scrollContainerBoundaries = getScrollContainerBoundaries(state);
  const scrollPosition = getScrollPositionForSectionToolbar(scrollContainerBoundaries, ownProps.containerRef);
  const section = getSectionById(state, ownProps.sectionId);
  return {
    section,
    canHideSection: getCanHideSection(state, section),
    sectionHasBlogRssModule: getSectionHasBlogRssModule(state, section),
    sectionHasWebversionAndIsVariant: getSectionHasWebversionAndIsVariant(state, section),
    isSingleColumnFullWidth,
    canSaveLayouts: getCanSaveLayouts(state),
    portalHasSavedLayouts: getPortalHasSavedLayouts(state),
    scrollPosition,
    sectionOptionsKeys: getSectionOptionsKeys(state, section),
    activeBreakpointName: getActiveBreakpointName(state),
    isTrellisTheme: getIsTrellisTheme(state)
  };
};
export default connect(mapStateToProps, {
  removeSection,
  cloneSection,
  updateSectionBreakpointStyle
})(AsyncSectionToolbar);